const validateEmail = (email) => {
  const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email.toLowerCase());
};

const validatePhoneNumber = (number) => {
  const reg = /^([2-9]{1}[0-9]{2})[2-9]{1}[0-9]{2}[0-9]{4}$/;
  return reg.test(number);
};

export { validateEmail, validatePhoneNumber };

// TODO: maybe use something open source to solve this problem
// maybe this? https://github.com/epoberezkin/ajv#assigning-defaults
export const validateType = (attributes, meta) => {
  const att = attributes;
  const met = meta;

  if (met.Definitions) {
    met.Definitions.forEach((e) => {
      switch (e.type) {
        case 'array':
          if (Array.isArray(att[e.key])) {
            return; // true, this is valid
          }
          break;
        default:
          /* eslint-disable-next-line valid-typeof */
          if (typeof att[e.key] === e.type) {
            return; // true, this is valid
          }
      }
      att[e.key] = e.default;
    });
  }

  return { att, met };
};
